import { Formik, Form } from "formik";
import useTutorial from "../../../hooks/useTutorial";
import { BaSeInput, BaSeHeading5 } from "@base/react";

const TutorialTotalInvestment = () => {
  const PAGE_KEY = "investimentoTotal";

  useTutorial({
    currentStep: "10",
    pageKey: "investimentoTotal",
    previousKey: "custosIndiretosVariaveis",
    steps: [
      {
        element: ".total-investment",
        popover: {
          title: "Investimento Total",
          description: `Calcule os recursos necessários para seu negócio. Registre investimentos fixos e capital de giro para
            planejar sua estrutura financeira.`,
          side: "bottom",
          align: "center",
        },
        onHighlighted: () => {
          const sideBar = document.querySelector(".list-menu");
          if (sideBar) {
            sideBar.classList.remove("open");
          }
        },
      },
    ],
    onNextButtonClick: (driverObj) => {
      const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};

      if (tutorials["prazosDeRecebimento"]) {
        tutorials["prazosDeRecebimento"].finalizado = false;
      }

      tutorials[PAGE_KEY] = { ...tutorials[PAGE_KEY], finalizado: true };
      localStorage.setItem("tutorials", JSON.stringify(tutorials));

      const botaoProx = document.querySelector("#botaoSeguirTutorial button");
      botaoProx.click();
      driverObj.drive(0);
    },
  });

  return (
    <div className="step total-investment">
      <BaSeHeading5
        color="#005EB8"
        fontFamily="Alegreya Sans"
        isBold
        className="mt-0"
      >
        Investimento total
      </BaSeHeading5>

      <Formik>
        {() => (
          <Form>
            <BaSeInput
              isDisabled
              color="default"
              inputMode="decimal"
              typeInput="tel"
              placeholder="R$"
              maxLength={22}
              prefix="R$ "
              mask="decimal"
              size="medium"
              label="Valor investimento fixo"
              width="100%"
              showHelpButton
            />

            <BaSeInput
              isDisabled
              color="default"
              inputMode="decimal"
              typeInput="tel"
              placeholder="R$"
              maxLength={22}
              prefix="R$ "
              mask="decimal"
              size="medium"
              label="Valor Capital de Giro próprio "
              width="100%"
              showHelpButton
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TutorialTotalInvestment;
